module.exports = __webpack_public_path__ + "media/images/sp/specials/common/benefit/benefit_second_costume_free-6b621d659ff891cbf1cff3cb815f830f.jpg";